var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDai = function SvgDai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 125,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.281 18.1v98.58a57.804 57.804 0 0 0 14.889-13.017V31.119a57.808 57.808 0 0 0-14.889-13.017v-.003Z",
    fill: "#FDCC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.389 11.728v111.318a57.13 57.13 0 0 0 14.889-6.367V18.098a57.156 57.156 0 0 0-14.89-6.373v.003Z",
    fill: "#FCBB6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 9.778V125c5.149 0 10.14-.677 14.89-1.951V11.729A57.418 57.418 0 0 0 57.5 9.778Z",
    fill: "#FBAA48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.607 11.729v111.32A57.393 57.393 0 0 0 57.497 125V9.778c-5.15 0-10.14.677-14.89 1.95Z",
    fill: "#FB971E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.718 18.098v98.581a57.037 57.037 0 0 0 14.889 6.367V11.728a57.016 57.016 0 0 0-14.89 6.373v-.003ZM12.827 31.119v72.547a57.816 57.816 0 0 0 14.89 13.017V18.099a57.818 57.818 0 0 0-14.89 13.017v.003Z",
    fill: "#F88800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.252 55.38H.04v15.467h.061a57.398 57.398 0 0 0 12.725 32.816V31.119A57.44 57.44 0 0 0 1.252 55.383v-.003Z",
    fill: "#F78700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.17 31.118v72.547a57.416 57.416 0 0 0 12.725-32.816L115 55.385h-1.252A57.427 57.427 0 0 0 102.17 31.12v-.003Z",
    fill: "#FDDBB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 115.222c31.756 0 57.5-25.794 57.5-57.61C115 25.793 89.253 0 57.5 0S0 25.794 0 57.611c0 31.817 25.744 57.611 57.5 57.611Z",
    fill: "url(#dai_svg__a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 112.01c29.986 0 54.294-24.355 54.294-54.399S87.483 3.212 57.5 3.212c-29.982 0-54.294 24.355-54.294 54.399S27.515 112.01 57.5 112.01Z",
    fill: "url(#dai_svg__b)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.523 107.953c27.742 0 50.228-22.532 50.228-50.327 0-27.795-22.488-50.324-50.228-50.324-27.739 0-50.23 22.532-50.23 50.327 0 27.795 22.488 50.327 50.23 50.327v-.003Z",
    fill: "url(#dai_svg__c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.859 22.104c-16.146-16.178-40.53-19.072-59.624-8.68l68.288 68.42c10.37-19.13 7.482-43.563-8.664-59.74ZM92.859 93.45a50.797 50.797 0 0 0 3.83-4.296l-70.75-70.888a50.796 50.796 0 0 0-4.288 3.837 50.411 50.411 0 0 0-8.737 11.747l68.226 68.356a50.351 50.351 0 0 0 11.722-8.756h-.003Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.852 89.74v.212l-.01.008v.036h24.574a43.574 43.574 0 0 0 8.286-.673 38.288 38.288 0 0 0 8.358-2.654c1.16-.537 2.272-1.186 3.394-1.841l.856-.497a42.66 42.66 0 0 0 3.788-3.044 28.316 28.316 0 0 0 7.437-10.836.886.886 0 0 1 1.028-.673h6.692c.533 0 .709-.178.709-.78v-4.286c.035-.41.035-.826 0-1.236a1.3 1.3 0 0 1 .055-.321c.055-.213.11-.425-.055-.638h-5.591c-.676 0-.676-.071-.676-.673a36.184 36.184 0 0 0 0-6.478c-.036-.638.107-.638.602-.638h4.887c.569 0 .78-.142.78-.708v-5.808c-.017-.385-.026-.58-.128-.679-.105-.101-.308-.101-.72-.101h-6.339a.922.922 0 0 1-1.058-.745 28.4 28.4 0 0 0-2.766-5.417 34.119 34.119 0 0 0-3.789-4.71 31.23 31.23 0 0 0-6.23-4.815 34.613 34.613 0 0 0-11.083-4.108A40.462 40.462 0 0 0 59.116 27H32.561c-.71 0-.71.143-.71.709v19.085c0 .673-.142.673-.672.673h-7.613c-.566 0-.566.105-.566.495v6.231c0 .566.176.566.602.566h7.684c.566 0 .566.105.566.53v6.657c0 .602-.179.602-.637.602H23v6.728c0 .566.176.566.602.566h7.684c.566 0 .566.069.566.53v19.369Zm48.902-42.88a.69.69 0 0 1 0 .495h.171c-.071.212-.426.284-.426.284H39.64c-.674 0-.674-.143-.674-.674V34.396c0-.461.072-.673.602-.673h19.014a26.411 26.411 0 0 1 6.02.638 25.452 25.452 0 0 1 10.623 5.382 8.688 8.688 0 0 1 1.63 1.593c.999.992 1.876 2.096 2.62 3.294.495.701.92 1.448 1.28 2.23Zm1.693 15.65H39.814c-.43 0-.642 0-.747-.106-.102-.104-.102-.307-.102-.708v-6.302c0-.497.143-.673.673-.673h42.845c.461 0 .673.176.673.602a41.134 41.134 0 0 1 0 6.585c-.033.602-.25.602-.709.602Zm-1.695 7.365a8.262 8.262 0 0 0-1.81 0H39.674c-.53 0-.709 0-.709.709v12.288c0 .566 0 .71.71.71h18.129a9.056 9.056 0 0 0 2.582-.177 26.99 26.99 0 0 0 7.687-1.7 14.07 14.07 0 0 0 2.583-1.204h.247a23.004 23.004 0 0 0 9.88-9.945s.247-.536-.031-.676v-.005Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.281 18.1v98.58a57.804 57.804 0 0 0 14.889-13.017V31.119a57.808 57.808 0 0 0-14.889-13.017v-.003Z",
    fill: "#FDCC90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.389 11.728v111.318a57.13 57.13 0 0 0 14.889-6.367V18.098a57.156 57.156 0 0 0-14.89-6.373v.003Z",
    fill: "#FCBB6D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 9.778V125c5.149 0 10.14-.677 14.89-1.951V11.729A57.418 57.418 0 0 0 57.5 9.778Z",
    fill: "#FBAA48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.607 11.729v111.32A57.393 57.393 0 0 0 57.497 125V9.778c-5.15 0-10.14.677-14.89 1.95Z",
    fill: "#FB971E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.718 18.098v98.581a57.037 57.037 0 0 0 14.889 6.367V11.728a57.016 57.016 0 0 0-14.89 6.373v-.003ZM12.827 31.119v72.547a57.816 57.816 0 0 0 14.89 13.017V18.099a57.818 57.818 0 0 0-14.89 13.017v.003Z",
    fill: "#F88800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.252 55.38H.04v15.467h.061a57.398 57.398 0 0 0 12.725 32.816V31.119A57.44 57.44 0 0 0 1.252 55.383v-.003Z",
    fill: "#F78700"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.17 31.118v72.547a57.416 57.416 0 0 0 12.725-32.816L115 55.385h-1.252A57.427 57.427 0 0 0 102.17 31.12v-.003Z",
    fill: "#FDDBB1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 115.222c31.756 0 57.5-25.794 57.5-57.61C115 25.793 89.253 0 57.5 0S0 25.794 0 57.611c0 31.817 25.744 57.611 57.5 57.611Z",
    fill: "url(#dai_svg__d)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 112.01c29.986 0 54.294-24.355 54.294-54.399S87.483 3.212 57.5 3.212c-29.982 0-54.294 24.355-54.294 54.399S27.515 112.01 57.5 112.01Z",
    fill: "url(#dai_svg__e)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.523 107.953c27.742 0 50.228-22.532 50.228-50.327 0-27.795-22.488-50.324-50.228-50.324-27.739 0-50.23 22.532-50.23 50.327 0 27.795 22.488 50.327 50.23 50.327v-.003Z",
    fill: "url(#dai_svg__f)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.859 22.104c-16.146-16.178-40.53-19.072-59.624-8.68l68.288 68.42c10.37-19.13 7.482-43.563-8.664-59.74ZM92.859 93.45a50.797 50.797 0 0 0 3.83-4.296l-70.75-70.888a50.796 50.796 0 0 0-4.288 3.837 50.411 50.411 0 0 0-8.737 11.747l68.226 68.356a50.351 50.351 0 0 0 11.722-8.756h-.003Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.852 89.74v.212l-.01.008v.036h24.574a43.574 43.574 0 0 0 8.286-.673 38.288 38.288 0 0 0 8.358-2.654c1.16-.537 2.272-1.186 3.394-1.841l.856-.497a42.66 42.66 0 0 0 3.788-3.044 28.316 28.316 0 0 0 7.437-10.836.886.886 0 0 1 1.028-.673h6.692c.533 0 .709-.178.709-.78v-4.286c.035-.41.035-.826 0-1.236a1.3 1.3 0 0 1 .055-.321c.055-.213.11-.425-.055-.638h-5.591c-.676 0-.676-.071-.676-.673a36.184 36.184 0 0 0 0-6.478c-.036-.638.107-.638.602-.638h4.887c.569 0 .78-.142.78-.708v-5.808c-.017-.385-.026-.58-.128-.679-.105-.101-.308-.101-.72-.101h-6.339a.922.922 0 0 1-1.058-.745 28.4 28.4 0 0 0-2.766-5.417 34.119 34.119 0 0 0-3.789-4.71 31.23 31.23 0 0 0-6.23-4.815 34.613 34.613 0 0 0-11.083-4.108A40.462 40.462 0 0 0 59.116 27H32.561c-.71 0-.71.143-.71.709v19.085c0 .673-.142.673-.672.673h-7.613c-.566 0-.566.105-.566.495v6.231c0 .566.176.566.602.566h7.684c.566 0 .566.105.566.53v6.657c0 .602-.179.602-.637.602H23v6.728c0 .566.176.566.602.566h7.684c.566 0 .566.069.566.53v19.369Zm48.902-42.88a.69.69 0 0 1 0 .495h.171c-.071.212-.426.284-.426.284H39.64c-.674 0-.674-.143-.674-.674V34.396c0-.461.072-.673.602-.673h19.014a26.411 26.411 0 0 1 6.02.638 25.452 25.452 0 0 1 10.623 5.382 8.688 8.688 0 0 1 1.63 1.593c.999.992 1.876 2.096 2.62 3.294.495.701.92 1.448 1.28 2.23Zm1.693 15.65H39.814c-.43 0-.642 0-.747-.106-.102-.104-.102-.307-.102-.708v-6.302c0-.497.143-.673.673-.673h42.845c.461 0 .673.176.673.602a41.134 41.134 0 0 1 0 6.585c-.033.602-.25.602-.709.602Zm-1.695 7.365a8.262 8.262 0 0 0-1.81 0H39.674c-.53 0-.709 0-.709.709v12.288c0 .566 0 .71.71.71h18.129a9.056 9.056 0 0 0 2.582-.177 26.99 26.99 0 0 0 7.687-1.7 14.07 14.07 0 0 0 2.583-1.204h.247a23.004 23.004 0 0 0 9.88-9.945s.247-.536-.031-.676v-.005Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__a",
    x1: 25.155,
    y1: 5.491,
    x2: 101.88,
    y2: 128.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FEE6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBA63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__b",
    x1: 16.975,
    y1: 7.716,
    x2: 101.297,
    y2: 111.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FDD7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FEDDB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__c",
    x1: 94.072,
    y1: 104.078,
    x2: 30.635,
    y2: 23.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDBB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__d",
    x1: 25.155,
    y1: 5.491,
    x2: 101.88,
    y2: 128.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FEE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FEE6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBA63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__e",
    x1: 16.975,
    y1: 7.716,
    x2: 101.297,
    y2: 111.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FDD7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FEDDB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dai_svg__f",
    x1: 94.072,
    y1: 104.078,
    x2: 30.635,
    y2: 23.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAA48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDDBB1"
  })))));
};
export { SvgDai as ReactComponent };
export default __webpack_public_path__ + "static/dai.17d2d232.svg";